/* eslint-disable prettier/prettier */
import flatpickr from "flatpickr"
import { Swedish } from 'flatpickr/dist/l10n/sv'

const calendarEl = document.querySelector('#calendar') as HTMLElement
const calendarItems = document.querySelectorAll('.calendar-block--item') as NodeListOf<HTMLElement>
const eventDates: string[] = []
const calendarInfo = document.querySelector('#calendar-info-text') as HTMLElement
const calendarEventSection = document.querySelector('#calendar-event-text') as HTMLElement
const closeEventSection = document.querySelector('.calendar-block--text--close') as HTMLButtonElement
const calendarBlurbs = document.querySelectorAll('.calendar-burb--card') as NodeListOf<HTMLAnchorElement>

calendarItems.forEach(item => {
    if (item.hasAttribute('data-date') && item.getAttribute('data-date') != null)
    {
        eventDates.push(item.getAttribute('data-date'))
    }  
})

const hideInfoItem = () => {
    calendarInfo.style.display = 'none'
}
const showInfoItem = () => {
    calendarInfo.style.display = 'block'
    calendarEventSection.style.display = 'none'
}
const showEventSection = () => {
    calendarEventSection.style.display = 'block'
}
const hideAllItems = () => {
    calendarItems.forEach(item => {
        item.style.display = 'none'
    })
}
const showItem = (dateStr: string) => {
    const matchingItems = document.querySelectorAll('[data-date="' + dateStr + '"]') as NodeListOf<HTMLElement>
    if (matchingItems)
    {
        matchingItems.forEach(item => {
            item.style.display = 'block'
        })
    }
}
const updateUI = () => {
    const weekdayContainer = document.querySelector('.flatpickr-weekdaycontainer') as HTMLElement
    const weekdays = weekdayContainer?.querySelectorAll('span')

    if (weekdays.length >= 7)
    {
        weekdays[0].innerText = 'M'
        weekdays[1].innerText = 'T'
        weekdays[2].innerText = 'O'
        weekdays[3].innerText = 'T'
        weekdays[4].innerText = 'F'
        weekdays[5].innerText = 'L'
        weekdays[6].innerText = 'S'
    }
}
export default function initCalendar() {
    const calendar = flatpickr(calendarEl, {
        inline: true,
        enable: eventDates,
        locale: Swedish,
        monthSelectorType: 'static',
        nextArrow: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
        `,
        prevArrow: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg>
        `,
        onChange: (selecedDates, dateStr, instance) => {
            hideInfoItem()
            hideAllItems()
            showEventSection()
            showItem(dateStr)

            if (window.innerWidth < 900) {
                calendarEventSection.scrollIntoView()
            }
        }
    })
    
    if (closeEventSection) 
    {
        closeEventSection.addEventListener('click', () => {
            calendar.clear()
            hideAllItems()
            showInfoItem()
        })
    }

    if (calendarBlurbs.length > 0)
    {
        calendarBlurbs.forEach(blurb => {
            if (blurb.hasAttribute('data-next'))
            {
                blurb.addEventListener('click', () => {
                    const next = blurb.getAttribute('data-next')
                    calendar.setDate(next, true)
                })
            }
        })
    }

    updateUI()
}